import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { CenteredLoader } from '@playbookux/playbook-web-core';
import { UNDISMISS_APPROVAL } from '../approvals/graphql';
import { getTestSessions } from './graphql';
import {
  ApprovalWrapper,
  Button,
  ButtonContainer,
  Modal,
  ModalApprovalContainer,
  ModalMessage,
  ModalTitle,
  SegmentWrapper,
} from './styles';

const UndismissBtn = (props) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [testSessions, setTestSessions] = useState([]);
  const [loading, setIsLoading] = useState(false);

  const { data, context } = props;
  const { projectId, projectName } = data || {};
  const params = {
    projectId,
  };

  const handleCloseDialog = () => {
    setShowConfirm(false);
  };

  const handleOpenDialog = async () => {
    const segmentData = {};
    const segmentsArray = [];
    setShowConfirm(true);
    setIsLoading(true);

    const { testSessionsApprovalsTab } = await getTestSessions(params);

    testSessionsApprovalsTab.forEach((item) => {
      if (item.approved) {
        const segmentName = item.tester.segment.name;
        if (!segmentData[segmentName]) {
          segmentData[segmentName] = [];
        }
        segmentData[segmentName].push(item);
      }
    });

    Object.keys(segmentData).sort().forEach((segmentName) => {
      segmentsArray.push({
        segmentName,
        data: segmentData[segmentName],
      });
    });

    setTestSessions(segmentsArray);
    setIsLoading(false);
  };

  const [undismissApproval] = useMutation(UNDISMISS_APPROVAL);

  const handleUndismissApproval = async () => {
    await undismissApproval({
      variables: {
        projectId,
      },
    });

    context.updateRow((state) => {
      const newData = state.map((project) => {
        if (project.projectId === projectId) {
          return {
            ...project,
            status: 'In Progress',
          };
        }

        return project;
      });

      return (newData);
    });

    props.node.setDataValue('status', 'In Progress');
    handleCloseDialog();
  };

  return (
    <>
      <a role="button" onClick={handleOpenDialog} tabIndex={0} onKeyDown={handleOpenDialog}>Undismiss</a>

      <Modal
        open={showConfirm}
        closeOnEscape
        closeOnDimmerClick
        onClose={handleCloseDialog}
      >
        {loading
          ? <CenteredLoader />
          : (
            <>
              <ModalTitle>{`Do you want to undismiss approvals for ${projectName}?`}</ModalTitle>

              <ModalApprovalContainer>
                {Object.keys(testSessions).length > 0
                  ? (
                    testSessions?.map((testSessionBySegment) => (
                      <SegmentWrapper key={testSessionBySegment.segmentName}>
                        <h2>{testSessionBySegment.segmentName}</h2>

                        {testSessionBySegment.data.map((approval) => (
                          <ApprovalWrapper key={approval.id}>
                            <span>{approval.tester.user.profile.firstName}</span>
                            <span>{approval.tester.user.profile.lastName}</span>
                          </ApprovalWrapper>
                        ))}
                      </SegmentWrapper>
                    )))
                  : <ModalMessage>No approvals found for this test session.</ModalMessage>}
              </ModalApprovalContainer>

              <ButtonContainer>
                <Button
                  type="button"
                  onClick={handleUndismissApproval}
                >
                  Yes
                </Button>

                <Button
                  type="button"
                  onClick={handleCloseDialog}
                >
                  No
                </Button>
              </ButtonContainer>
            </>
          )}
      </Modal>
    </>
  );
};

UndismissBtn.propTypes = {
  data: PropTypes.objectOf(PropTypes.shape({
    projectName: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
  })).isRequired,
  context: PropTypes.objectOf(PropTypes.shape({
    updateRow: PropTypes.func.isRequire,
  })).isRequired,
  node: PropTypes.func.isRequired,
};

export default UndismissBtn;
